import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  RlLocationType,
  RlPicType,
  ProductCategoryType,
  DeleteReasonType,
  TagType,
} from '../../types/rlFilter'

interface InitialStateType {
  locationList: RlLocationType[]
  picList: RlPicType[]
  productCategory: ProductCategoryType[]
  deleteReasons: DeleteReasonType[]
  tagList: TagType[]
}

const initialState: InitialStateType = {
  locationList: [],
  picList: [],
  productCategory: [],
  deleteReasons: [],
  tagList: [],
}

export const sliceName = 'reorderListFilter'

export const reorderListFilter = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLocationList: (state, action: PayloadAction<RlLocationType[]>) => {
      state.locationList = action.payload
    },
    setPicList: (state, action: PayloadAction<RlPicType[]>) => {
      state.picList = action.payload
    },
    setProductCategory: (state, action: PayloadAction<ProductCategoryType[]>) => {
      state.productCategory = action.payload
    },
    setDeleteReasons: (state, action: PayloadAction<DeleteReasonType[]>) => {
      state.deleteReasons = action.payload
    },
    setTagList: (state, action: PayloadAction<TagType[]>) => {
      state.tagList = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setLocationList,
  setPicList,
  setProductCategory,
  setDeleteReasons,
  setTagList,
  resetState,
} = reorderListFilter.actions

export default reorderListFilter.reducer
